// A card (payment) surcharge that came to $0.00, e.g. since card surcharges were removed on
// 1 Oct 2026. It adds nothing to any total, so it is not worth a row. Mirrors the POS's
// AdjustmentType.isZeroCardSurcharge: a holiday surcharge is never a card surcharge.
export const isZeroCardSurcharge = (adjustment) => {
  if (!adjustment) {
    return false;
  }
  const type = String(adjustment.adjustmentType || '').toLowerCase();
  const isCardSurcharge =
    type.endsWith('card surcharge') ||
    (adjustment.isPaymentSurcharge === true && type.endsWith('surcharge') && type !== 'holiday surcharge');
  // Anything that would show as $0.00, including -0.00.
  return isCardSurcharge && Math.abs(Number(adjustment.price) || 0) < 0.005;
};

export const visibleAdjustments = (adjustments) => (adjustments || []).filter((adjustment) => !isZeroCardSurcharge(adjustment));
